export default __webpack_public_path__ + "static/media/xmlexe.b58aa3c4.svg";